import { l } from '@manychat/manyui'

import { KnowledgeEntry, KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export const getSidebarTitle = ({
  entry,
  newEntryType,
}: {
  entry: KnowledgeEntry | null
  newEntryType: string
}) => {
  if (!entry) {
    switch (newEntryType) {
      case KnowledgeEntryType.TEXT:
        return l.translate('Add text')
      case KnowledgeEntryType.LINK:
        return l.translate('Add link')
      default:
        return ''
    }
  }

  if (entry.title) {
    return entry.title
  }

  return l.translate('Untitled')
}
